/**
 * Compact number formatter consistent with the chart's summary/axis labels:
 * 5000 → "5k", 7500 → "7.5k", 1_200_000 → "1.2M".
 *
 * Dependency-free (no date-utils) so it can be imported by the insight logic
 * without pulling in the rest of `utils.ts`. Re-exported from `utils.ts`.
 */
export function formatNumber(value: number): string {
  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`
  }
  if (value >= 1_000) {
    return `${(value / 1_000).toFixed(1).replace(/\.0$/, '')}k`
  }
  return value.toLocaleString()
}
